/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Text, View, ActionButton, Tooltip } from '@components/atoms'
import { PdfPagenation } from './PdfPagenation'

import { grey } from '@mui/material/colors'

interface PropsType {
	mode: 'none' | 'add' | 'update' | 'sign'
	scale: number
	showAddText?: boolean
	showAddDate?: boolean
	showReset?: boolean
	showDownload?: boolean
	totalPages: number
	page: number
	setPage: (page: number) => void
	onSignatureClick?: () => void
	onAddDateClick?: () => void
	onAddTextClick?: () => void
	onResetClick?: () => void
	onDownloadClick?: () => void
	onZoomIn?: () => void
	onZoomIOut?: () => void
	isHandleMode?: boolean
	onToggleHandleMode?: () => void
	isAbleToSign: boolean
	isSigned: boolean
	onSignatureSubmit: () => any
	onReadyToSign: () => void
}

export const PdfToolbar = (props: PropsType) => {
	const { mode, isAbleToSign } = props

	const showAddText = props.showAddText ?? false
	const showAddDate = props.showAddDate ?? false
	const showReset = props.showReset ?? false
	const showDownload = props.showDownload ?? false

	const onAddDateClick = () => {
		if (props.onAddDateClick) {
			props.onAddDateClick()
		}
	}
	const onAddTextClick = () => {
		if (props.onAddTextClick) {
			props.onAddTextClick()
		}
	}
	const onResetClick = () => {
		if (props.onResetClick) {
			props.onResetClick()
		}
	}
	const onDownloadClick = () => {
		if (props.onDownloadClick) {
			props.onDownloadClick()
		}
	}

	const onZoomIn = () => {
		if (props.onZoomIn) {
			props.onZoomIn()
		}
	}

	const onZoomIOut = () => {
		if (props.onZoomIOut) {
			props.onZoomIOut()
		}
	}

	return (
		<View css={style}>
			{mode === 'none' && (
				<>
					<View className="scaleView">
						<Tooltip title="축소">
							<ActionButton iconName="minus-circle-outline" onClick={onZoomIOut} />
						</Tooltip>
						<Text category="p2" className="scale">
							{`${props.scale}%`}
						</Text>
						<Tooltip title="확대">
							<ActionButton iconName="plus-circle-outline" onClick={onZoomIn} />
						</Tooltip>
					</View>
					<Tooltip title="움직이기">
						<ActionButton
							iconName={
								props.isHandleMode
									? 'hand-back-left-off-outline'
									: 'hand-back-left-outline'
							}
							onClick={props.onToggleHandleMode}
						/>
					</Tooltip>
				</>
			)}

			<PdfPagenation
				mode={mode}
				page={props.page}
				setPage={props.setPage}
				totalPages={props.totalPages}
			/>

			<View className="buttonListView">
				{!props.isSigned && mode === 'sign' && (
					<ActionButton
						iconName="pen"
						tooltip="서명하기"
						title="서명하기"
						variant="contained"
						onClick={props.onReadyToSign}
						buttonColor="primary"
						disabled={!isAbleToSign}
						style={{ position: 'absolute', right: '0.5rem', top: '0.8rem' }}
					/>
				)}
				{props.isSigned && (
					<>
						<ActionButton
							iconName="pen"
							tooltip="서명 다시 하기"
							title="서명 다시 하기"
							variant="contained"
							onClick={props.onReadyToSign}
							style={{ background: grey[50] }}
						/>
						<ActionButton
							iconName="check-bold"
							tooltip="저장하기"
							title="저장하기"
							variant="contained"
							onClick={props.onSignatureSubmit}
							buttonColor="primary"
							style={{ position: 'absolute', right: '0.5rem' }}
						/>
					</>
				)}
				{showAddDate && (
					<Tooltip title="날짜 입력">
						<ActionButton
							iconName="calendar-clock"
							tooltip="날짜 입력"
							onClick={onAddDateClick}
						/>
					</Tooltip>
				)}
				{showAddText && (
					<Tooltip title="텍스트">
						<ActionButton
							iconName="format-text"
							tooltip="텍스트 입력"
							onClick={onAddTextClick}
						/>
					</Tooltip>
				)}
				{showReset && (
					<Tooltip title="초기화">
						<ActionButton
							iconName="delete-forever"
							tooltip="초기화"
							onClick={onResetClick}
						/>
					</Tooltip>
				)}
				{showDownload ? (
					<View>
						<View className="downloadView mobile">
							<Tooltip title="다운로드">
								<ActionButton iconName="download" onClick={onDownloadClick} />
							</Tooltip>
						</View>
					</View>
				) : null}
			</View>
		</View>
	)
}

const style = css({
	height: '3.5rem',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	padding: '0 0.5rem',

	'.scaleView': {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',

		'.scale': {
			width: '2.5rem',
		},
	},

	'.buttonListView': {
		display: 'flex',

		'.MuiButtonBase-root': {
			marginBottom: '0.1rem',
			'.text': {
				marginBottom: '0.1rem',
				fontSize: '11px',
			},
		},
	},

	'.downloadView': {
		display: 'none',

		'&.mobile': {
			display: 'block',
		},
	},

	'@media (max-width:400px)': {
		padding: 0,

		'.scaleView': {
			'.scale': {
				width: '1.3rem',
				fontSize: '10px',
			},
		},

		'.downloadView': {
			display: 'block',

			'&.mobile': {
				width: '7rem',
			},
		},
	},

	'@media (max-width:350px)': {
		'.downloadView': {
			'&.mobile': {
				width: '5rem',
			},
		},
	},
})
